import React, { useContext } from 'react';
import { BasicPreloader } from '../../shared/BasicPreloader';
import DesignFeedbackGroupConfirmationPage from './DesignFeedbackGroupConfirmationPage';
import DesignFeedbackGroupRequestPage from './DesignFeedbackGroupRequestPage';
import { DesignFeedbackGroupResponseContext } from '../../contexts/DesignFeedbackGroupResponseContext';
import DesignFeedbackGroupRequestContext from '../../contexts/DesignFeedbackGroupRequestContext';
import DesignFeedbackErrorPage from './DesignFeedbackErrorPage';

const DesignFeedbackGroupPage = () => {
  const { isRequestLoading, isFeedbackProcessing, isPreviewDataError } =
    useContext(DesignFeedbackGroupRequestContext);

  const { isFeedbackSubmitted } = useContext(
    DesignFeedbackGroupResponseContext
  );

  if (isRequestLoading) {
    return <BasicPreloader isCentered my={9} />;
  }

  if (isFeedbackProcessing || isFeedbackSubmitted) {
    return <DesignFeedbackGroupConfirmationPage />;
  }

  if (isPreviewDataError) {
    return <DesignFeedbackErrorPage />;
  }

  return <DesignFeedbackGroupRequestPage />;
};

export default DesignFeedbackGroupPage;
